module.exports = __webpack_public_path__ + "static/media/Quienes-somos.a6ad85a6.png";